/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React, { useEffect, useState } from "react";
import { PencilSquareIcon } from "@heroicons/react/24/outline";

import { queryWindFarms } from "src/services/AmplifyQuery";

import EditWindFarmModal from "src/components/modals/EditWindFarm.react";

/**
 * The WindFarms component
 *
 * @author Thais Watanabe
 */
const WindFarms = () => {
  const [windFarms, setWindFarms] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedWindFarm, setSelectedWindFarm] = useState(null);

  /* useEffect */
  useEffect(() => {
    // Scroll to top
    window.scrollTo(0, 0);
  }, []);

  /* useEffect */
  useEffect(() => {
    fetchWindFarms();
  }, []);

  /**
   * showEdit
   * @param {*} windFarm
   */
  function showEdit(windFarm) {
    setSelectedWindFarm(windFarm);
    setIsOpen(!isOpen);
  }

  /**
   * fetchWindFarms
   */
  async function fetchWindFarms() {
    queryWindFarms(null, setWindFarms);
  }

  return (
    <>
      <section aria-labelledby="billing_history_heading">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 md:flex md:items-center md:justify-between md:space-x-5 lg:max-w-7xl lg:px-8">
          <div className="flex items-center space-x-5">
            <div>
              <h2
                id="billing_history_heading"
                className="text-lg leading-6 font-medium text-gray-900"
              >
                発電所一覧
              </h2>
            </div>
          </div>
        </div>
        <div className="mt-6 flex flex-col overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  発電所名称
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  発電事業者
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {windFarms.length < 1 && (
                <tr>
                  <td
                    colSpan="4"
                    className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                  >
                    <div className="loader"></div>
                  </td>
                </tr>
              )}
              {windFarms
                .sort((a, b) =>
                  a["name"].localeCompare(b["name"], undefined, {
                    numeric: true,
                    sensitivity: "base",
                  })
                )
                .map((windFarm, i) => (
                  <tr key={i}>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {windFarm.name}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {windFarm.owner}
                    </td>
                    <td>
                      <button
                        onClick={() => showEdit(windFarm)}
                        className="rounded-full flex items-center text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-teal-500"
                      >
                        {/* <!-- Heroicon name: pencil-alt --> */}
                        <PencilSquareIcon className="h-5 w-5" />
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </section>

      <EditWindFarmModal
        setIsOpen={setIsOpen}
        isOpen={isOpen}
        selectedWindFarm={selectedWindFarm}
        setSelectedWindFarm={setSelectedWindFarm}
      />
    </>
  );
};

export default WindFarms;
